import React, { useState } from 'react'
import { Box, ButtonBase, Dialog, DialogTitle, IconButton, makeStyles, Typography, useTheme } from '@material-ui/core'
import { Close } from '@material-ui/icons'

import AppBar from './AppBar'
import DialogContent from './DialogContent'

import configImg from '~/assets/configPosition.png'
import useViewportSizes from '~/components/useViewportSize'
import { infoUtilNao, infoUtilSim } from '~/track'
import { useLiterals } from '~/components/Literals'

const useStyle = makeStyles((theme) => ({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dialogContent: {
    marginTop: 10,
  },
  question: {
    marginTop: 20,
    marginBottom: 20,
    fontWeight: 'bold',
  },
  answerContainer: {
    background: '#EEEBEB',
    padding: '10px 15px',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginTop: 20,
    marginBottom: -30,
  },
  answerButton: {
    marginRight: 10,
    color: theme.palette.text.primary,
    textDecoration: 'underline',
    '&:hover': {
      fontWeight: 'bold',
    },
  },
}))

export default function SeeMore({ open, onClose }) {
  const classes = useStyle()
  const theme = useTheme()
  const viewport = useViewportSizes()
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth
  const [feedbackMessage, setFeedbackMessage] = useState(false)
  const { getLiteral } = useLiterals()

  const handleSendFeedback = (feedback) => {
    feedback ? infoUtilSim() : infoUtilNao()
    setFeedbackMessage(true)
  }

  return (
    <Dialog maxWidth="sm" open={open} onClose={onClose} fullScreen={isMobile} disableAutoFocus>
      {isMobile ? (
        <AppBar title={getLiteral('2512').slice(0, -1)} onClose={onClose} />
      ) : (
        <DialogTitle>
          <Box className={classes.dialogTitle}>
            <Typography variant="h6">{getLiteral('2512').slice(0, -1)}</Typography>
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
      )}
      {/* <Divider /> */}
      <DialogContent className={classes.dialogContent} isMobile={isMobile}>
        <Typography className={classes.question} component="div">
          {getLiteral('2513')}
        </Typography>
        <Typography component="div">{getLiteral('2514')}</Typography>

        <Typography className={classes.question} component="div">
          {getLiteral('2515')}
        </Typography>
        <Typography component="div">
          {getLiteral('2516')}
          <br />
          <br />
          <b>{getLiteral('2517')}</b> {getLiteral('2518')}
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <img src={configImg}></img>
          </Box>
          {getLiteral('2519')}
          <br />
          <br />
          <b>{getLiteral('2520')}</b> {getLiteral('2521')}{' '}
          <Typography variant="subtitle2" component="span">
            {getLiteral('2522')}
          </Typography>
        </Typography>
        <Box component="div" className={classes.answerContainer}>
          {feedbackMessage ? (
            <Typography style={{ fontWeight: 'bold' }}>{getLiteral('2523')}</Typography>
          ) : (
            <>
              <Typography style={{ fontWeight: 'bold' }}>{getLiteral('2524')}</Typography>
              <Box display="flex">
                <ButtonBase className={classes.answerButton} component="a" onClick={() => handleSendFeedback(true)}>
                  {getLiteral('1843')}
                </ButtonBase>
                <ButtonBase className={classes.answerButton} component="a" onClick={() => handleSendFeedback(false)}>
                  {getLiteral('1844')}
                </ButtonBase>
              </Box>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  )
}
